import { render, staticRenderFns } from "./AppVerifiedBuyerBadgeImage.vue?vue&type=template&id=41c867e1&scoped=true"
import script from "./AppVerifiedBuyerBadgeImage.vue?vue&type=script&lang=js"
export * from "./AppVerifiedBuyerBadgeImage.vue?vue&type=script&lang=js"
import style0 from "./AppVerifiedBuyerBadgeImage.vue?vue&type=style&index=0&id=41c867e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c867e1",
  null
  
)

export default component.exports